import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'c-tab-item-subtitle',
  templateUrl: './tab-item-subtitle.component.html',
  styleUrls: ['./tab-item-subtitle.component.scss']
})
export class TabItemSubtitleComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
